/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.serverTime = function() {
    var elemById = expocadfx.element.elementById;
	var config = expocadfx.config;

	////////////////////////////////////////////////////////////////////////////////
	//
    var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	////////////////////////////////////////////////////////////////////////////////////////
	var displayTime = null;
	var clkRefreshCount = 0;
    var serverOffset = 0;
    var tickTimer = null;	
			
//	function setColor( clr) {
//		elemById( "txtDate").style.color = clr;
//		elemById( "txtTime").style.color = clr;
//		elemById( "txtTimeZone").style.color = clr;
//	}
	
	function tick() {
        var ms = 0;
		clkRefreshCount++;
		
		if( displayTime === null) {
			displayTime = new Date();
		}
        
        ms = displayTime.getTime() + 1000;
        displayTime = new Date( ms);
        
        elemById( "txtTime").textContent = formatTime( displayTime);

            //  IF ( display time == 00:00:00) ==>  force refresh to update date !!
        if( displayTime.hours === 0 && displayTime.minutes === 0 && displayTime.seconds === 0) {
            clkRefreshCount = 181;
        }

        if( clkRefreshCount >= 180) {
            clkRefreshCount = 0;
            
            return true;
        }
		
		return false;
	}
	
	////////////////////////////////////////////////////////////////////////////////////
	// Typical Server response to request for time
	//	<Response>
	//		<DateFormat>dd MMM yyyy</DateFormat>
	//		<Offset>-06:00:00</Offset> OR <Offset>-0600</Offset>  depending on server type
	//		<OffsetSeconds>-21600</OffsetSeconds>
	//		<TimeZone/>						  // abbreviation from .php on Apache server
	//		<TimeZoneName>Central Standard Time</TimeZoneName> // from .aspx on Windows server
	//		<DateParams>2015,2,9,14,35,51</DateParams>
	//	</Response>
	//////////////////////////////////////////////////////////////////////////////////////
	
	function updateTimeFromServer( success, data) {
        if( !success) {
            console.log( "server time request failed");
            return;
        }
		
		var dateTime = null;
		var zone = "";
        var zoneName = "";
        var date = null;
		var ar;
        var arZone;
        var word = "";
        var i;
        
			// split param string into array of year, month, date, hour, minute, second
        ar = data.getElementsByTagName("DateParams")[0].textContent.split(",");
			// Adjust month - server 1 based, browser O based
		ar[1] = ar[1] - 1;
		
		dateTime = new Date( ar[0], ar[1], ar[2], ar[3], ar[4], ar[5] );
        
            // Adjust for offset from options file
		if( config.serverTimeOffset !== 0) {
            if( serverOffset === 0) {
                serverOffset = parseInt( data.getElementsByTagName("OffsetSeconds")[0].textContent, 10) * 1000;
            }
			dateTime = new Date( dateTime.getTime() + config.serverTimeOffset - serverOffset);
		}
                                
        date = data.getElementsByTagName( "Date")[0].textContent;
		if( date !== null && date !== "") {
			elemById( "txtDate").textContent = date;
		}
		else {
            elemById( "txtDate").textContent = days[dateTime.getDay()] = ", " + months[ar[1]] + " " + ar[2] + ", " + ar[0];
		}
        
        elemById( "txtTime").textContent = formatTime( dateTime);
            
		zone = data.getElementsByTagName( "TimeZone")[0].textContent.trim();
        zoneName = data.getElementsByTagName( "TimeZoneName")[0].textContent;
        
		if( config.serverTimeZoneLabel !== "") {
			elemById( "txtTimeZone").textContent = config.serverTimeZoneLabel;
		}
		else if( zone !== "") {
			elemById( "txtTimeZone").textContent = zone;
		}
		else if( zoneName !== "") {
            arZone = zoneName.split( " ");
			for( i = 0; i < arZone.length; i++) {
				word = arZone[i];
				zone += word.charAt(0);
			}
			elemById( "txtTimeZone").textContent = zone;
		}
		displayTime = dateTime;
        
        if( tickTimer === null) {
            tickTimer = setInterval( tick, 1000);
        }
	}
    
    function formatTime( time) {
        var hours = "";
        var minutes = "";
        var seconds = "";
        var ampm = "AM";
        
        hours = time.getHours();
        if( hours > 12) {
            hours = hours - 12;
            ampm = "PM";
        }
        minutes = (time.getMinutes() < 10) ? "0" + time.getMinutes() : time.getMinutes();
        seconds = (time.getSeconds() < 10) ? "0" + time.getSeconds() : time.getSeconds();
        
		return hours + ":" +  minutes + ":" + seconds + " " + ampm;
    }
	
	function getServerTimeHtml() {
        var html = document.createElement( "div");
        var par = document.createElement( "p");
        var span = document.createElement( "span");
        
        html.style.color = config.serverTimeColor;
        html.setAttribute( "id", "sTimeDisplay");
        html.appendChild( par);
        
        span.setAttribute( "id", "txtDate");
        par.appendChild( span);
        
        span = document.createElement( "span");
        span.setAttribute( "id", "txtTime");
        par.appendChild( span);
        
        span = document.createElement( "span");
        span.setAttribute( "id", "txtTimeZone");
        par.appendChild( span);
        return html;
    }
    
    return {
        getServerTimeHtml: getServerTimeHtml,
        updateTimeFromServer: updateTimeFromServer
    };
};